/* ============================================================
   D&V Market — Landing por imágenes
   - Cada botón toma el color vivo de la imagen que tiene encima
     (igual que Saluha); si no se puede leer la imagen, queda el naranja.
   - La página toma un tinte muy suave de la primera imagen.
   - Botón fijo en celular: aparece al bajar y toma el color de la
     imagen que está en pantalla.
   ============================================================ */
(function () {
  'use strict';

  var root = document.getElementById('dv-landing');
  if (!root) return;
  var box = document.getElementById('imgLanding');
  var sticky = document.getElementById('stickyCta');

  /* ---------- utilidades de color ---------- */
  function lum(c) {
    function f(x) { x /= 255; return x <= 0.03928 ? x / 12.92 : Math.pow((x + 0.055) / 1.055, 2.4); }
    return 0.2126 * f(c[0]) + 0.7152 * f(c[1]) + 0.0722 * f(c[2]);
  }
  function rgb(c) { return 'rgb(' + (c[0] | 0) + ',' + (c[1] | 0) + ',' + (c[2] | 0) + ')'; }
  function rgba(c, a) { return 'rgba(' + (c[0] | 0) + ',' + (c[1] | 0) + ',' + (c[2] | 0) + ',' + a + ')'; }
  function mix(c, t, a) { return [c[0] + (t - c[0]) * a, c[1] + (t - c[1]) * a, c[2] + (t - c[2]) * a]; }
  function textOn(c) { return lum(c) > 0.5 ? '#15202b' : '#ffffff'; }

  // Lee la imagen en un canvas pequeño: franja inferior (tinte) y el color más vivo (botón).
  function imgColors(img) {
    try {
      var w = 36, h = Math.max(12, Math.min(140, Math.round(w * (img.naturalHeight / (img.naturalWidth || 1)))));
      var cv = document.createElement('canvas'); cv.width = w; cv.height = h;
      var ctx = cv.getContext('2d', { willReadFrequently: true });
      ctx.drawImage(img, 0, 0, w, h);
      var d = ctx.getImageData(0, 0, w, h).data;
      var bs = Math.floor(h * 0.84) * w * 4;
      var br = 0, bg = 0, bb = 0, bn = 0, best = null, bestS = -1;
      for (var i = 0; i < d.length; i += 4) {
        var r = d[i], g = d[i + 1], b = d[i + 2], a = d[i + 3];
        if (a < 200) continue;
        if (i >= bs) { br += r; bg += g; bb += b; bn++; }
        var mx = Math.max(r, g, b), mn = Math.min(r, g, b), val = mx / 255, sat = mx ? (mx - mn) / mx : 0;
        var s = sat * 0.72 + val * 0.28;
        if (sat > 0.33 && val > 0.22 && val < 0.96 && s > bestS) { bestS = s; best = [r, g, b]; }
      }
      return { band: bn ? [br / bn, bg / bn, bb / bn] : null, accent: best };
    } catch (e) {
      return null; // imagen de otro dominio sin CORS: se queda el naranja de la marca
    }
  }

  var pageTint = null;
  function setPageTint(band) {
    if (pageTint || !band || !box) return;
    pageTint = mix(band, 255, 0.9);
    box.style.background = rgb(pageTint);
  }
  function applyBtnColor(btn, a, shadow) {
    if (!btn || !a) return;
    var tint = pageTint || [250, 248, 247];
    if (Math.abs(lum(a) - lum(tint)) < 0.25) a = mix(a, 0, 0.24);
    btn.style.setProperty('background', 'linear-gradient(135deg, ' + rgb(mix(a, 255, 0.12)) + ' 0%, ' + rgb(a) + ' 55%, ' + rgb(mix(a, 0, 0.16)) + ' 100%)', 'important');
    btn.style.setProperty('color', textOn(a), 'important');
    if (shadow) btn.style.boxShadow = '0 10px 26px ' + rgba(a, 0.34);
  }

  /* ---------- colorear botones según su imagen ---------- */
  var imgs = box ? Array.prototype.slice.call(box.querySelectorAll('.imgl__img')) : [];
  function whenLoaded(img, fn) {
    if (img.complete && img.naturalWidth) fn(); else img.addEventListener('load', fn, { once: true });
  }
  if (root.dataset.colorAuto !== 'false') {
    imgs.forEach(function (img) {
      whenLoaded(img, function () {
        var c = imgColors(img);
        if (!c) return;
        img._accent = c.accent;
        if (c.band) setPageTint(c.band);
        var slide = img.closest('.imgl__slide');
        var cta = slide && slide.querySelector('.imgl__cta .btn');
        applyBtnColor(cta, c.accent, true);
        updateSticky();
      });
    });
  }

  /* ---------- botón fijo en celular ---------- */
  var raf = 0;
  function updateSticky() {
    raf = 0;
    if (!sticky) return;
    sticky.classList.toggle('is-visible', window.scrollY > 520);
    var btn = sticky.querySelector('.btn');
    if (!btn || !imgs.length) return;
    var mid = window.innerHeight / 2, cur = null, best = 1e9;
    for (var i = 0; i < imgs.length; i++) {
      var r = imgs[i].getBoundingClientRect();
      if (r.top <= mid && r.bottom >= mid) { cur = imgs[i]; break; }
      var dd = Math.abs((r.top + r.bottom) / 2 - mid);
      if (dd < best) { best = dd; cur = imgs[i]; }
    }
    if (cur && cur._accent) applyBtnColor(btn, cur._accent, false);
  }
  window.addEventListener('scroll', function () { if (!raf) raf = requestAnimationFrame(updateSticky); }, { passive: true });
  updateSticky();
})();
